import { ShieldCheck, UserCheck, UserRoundX, Users } from "lucide-react";
import type { UserStats } from "@/lib/users.api";
import { UserKpiCard } from "./UserKpiCard";

interface UsersStatsGridProps {
  stats?: UserStats;
  statsLoading: boolean;
}

export function UsersStatsGrid({ stats, statsLoading }: UsersStatsGridProps) {
  const watchCount = (stats?.inactive ?? 0) + (stats?.firstLogin ?? 0);

  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <UserKpiCard
        label="Total comptes"
        value={statsLoading ? "..." : String(stats?.total ?? 0)}
        detail={`${stats?.active ?? 0} actifs`}
        icon={Users}
        tone="gold"
      />
      <UserKpiCard
        label="Agents"
        value={statsLoading ? "..." : String(stats?.agents ?? 0)}
        detail={`${stats?.managers ?? 0} managers`}
        icon={UserCheck}
        tone="success"
      />
      <UserKpiCard
        label="Administration"
        value={statsLoading ? "..." : String((stats?.admins ?? 0) + (stats?.superAdmins ?? 0))}
        detail={`${stats?.superAdmins ?? 0} super admin`}
        icon={ShieldCheck}
        tone="neutral"
      />
      <UserKpiCard
        label="À surveiller"
        value={statsLoading ? "..." : String(watchCount)}
        detail={`${stats?.inactive ?? 0} désactivés · ${stats?.firstLogin ?? 0} 1ère connexion`}
        icon={UserRoundX}
        tone={watchCount > 0 ? "danger" : "neutral"}
      />
    </div>
  );
}
